import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  IconButton,
  useTheme,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { Close } from "@mui/icons-material";
import { useBodyScrollLock } from "../../hooks/useBodyScrollLock";

interface DeleteModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  maxWidth = "md",
}) => {
  const theme = useTheme();
  useBodyScrollLock(open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableScrollLock
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
          maxHeight: "90vh",
        },
      }}
    >
      {/* Modern Header */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${theme.palette.error.main} 0%, ${theme.palette.error.dark} 100%)`,
          color: "common.white",
          p: 3,
          position: "relative",
        }}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "common.white",
            bgcolor: alpha(theme.palette.common.white, 0.1),
            "&:hover": {
              bgcolor: alpha(theme.palette.common.white, 0.2),
            },
          }}
        >
          <Close />
        </IconButton>

        <Typography variant="h5" fontWeight={600} sx={{ mb: 1, pr: 4 }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body2" sx={{ opacity: 0.9 }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <DialogContent sx={{ p: 0, bgcolor: "grey.50" }}>
        <Box sx={{ p: 3 }}>{children}</Box>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteModal;
